import { IFetchReparcelingSimulationsDTO } from 'modules/customer/domain/dtos';
import { IReparcelingSimulationsRepository } from 'modules/customer/domain/repositories';

export class FetchReparcelingSimulationsUseCase {
  constructor(
    private reparcelingSimulationsRepository: IReparcelingSimulationsRepository,
  ) {}

  public async execute({ hash, cash }: IFetchReparcelingSimulationsDTO) {
    return this.reparcelingSimulationsRepository.findAllByReparcelingHash({
      hash,
      cash,
    });
  }
}
